import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Config from "./Config";
import { AuthProvider } from "./utils/AuthContext";
import { UploadProvider } from "./contexts/UploadContext";
import UploadWidget from "./components/UploadWidget";
import CookieConsent from "./components/CookieConsent";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);

const app = (
  <BrowserRouter
    future={{
      v7_relativeSplatPath: true,
      v7_startTransition: true,
    }}
  >
    <ScrollToTop />
    <AuthProvider>
      <UploadProvider>
        <App />
        <UploadWidget />
        <CookieConsent />
      </UploadProvider>
    </AuthProvider>
  </BrowserRouter>
);

if (Config.STRICT_MODE) {
  root.render(<React.StrictMode>{app}</React.StrictMode>);
} else {
  root.render(app);
}
